import { endPoint, endPointOryton } from './base.config';

export const company = {
  getOrytonCompanies: `${endPoint}company/get-oryton-companies`,
  getRgbIntegration: `${endPoint}company/rgb-integration`,
  addRgbIntegration: `${endPoint}company/rgb-integration`,
  getOwnCompany: `${endPointOryton}/api/companies/products/1/own-company`,// 1 = Oryton
};
